export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Статус"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сайт"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Дүкен ID"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Дүкен параметрлері"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Төлем сілтемесі"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Белсенді"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Белсенді емес"])}
}